


export default function SuggestedArticlesSection() {
  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.opacity = '0.8'
  }

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.opacity = '1'
  }

  const suggestedArticles = [
    {
      id: 1,
      image: '/Editorial/Result - All/2.png',
      category: 'Culture',
      title: 'New Asia Michelin restaurants',
      description: 'It\'s here. 6 New Additions to the MICHELIN Guide Hong Kong & Macau',
      slug: 'new-asia-michelin-restaurants'
    },
    {
      id: 2,
      image: '/Editorial/Result - All/3.png',
      category: 'Lifestyle',
      title: 'Bangkok\'s Luxury Scene',
      description: 'Exploring the finest luxury experiences in Thailand\'s capital city',
      slug: 'bangkok-luxury-scene'
    },
    {
      id: 3,
      image: '/Editorial/Result - All/4.png',
      category: 'Travel',
      title: 'Southeast Asian Culinary Journey',
      description: 'A gastronomic adventure through the region\'s most celebrated dishes',
      slug: 'southeast-asian-culinary-journey'
    }
  ]

  return (
    <section 
      className="w-full"
      style={{
        backgroundColor: '#FFFFFF',
        paddingTop: '80px',
        paddingBottom: '80px',
        paddingLeft: '64px',
        paddingRight: '64px'
      }}
    >
      {/* Section Title */}
      <div className="text-center" style={{ marginBottom: '64px' }}>
        <h2
          style={{
            fontFamily: 'Cardo',
            fontSize: '48px',
            color: '#000000',
            fontWeight: 'normal',
            marginBottom: '16px'
          }}
        >
          Expand Your Horizons
        </h2>
        <p
          style={{
            fontFamily: 'Plus Jakarta Sans',
            fontSize: '16px',
            color: '#7B7B7B',
            maxWidth: '600px',
            margin: '0 auto'
          }}
        >
          Discover more curated stories and insights from the world of luxury lifestyle and fine dining
        </p>
      </div>

      {/* Articles Grid */}
      <div 
        className="flex justify-center"
        style={{ gap: '32px' }}
      >
        {suggestedArticles.map((article) => (
          <div 
            key={article.id}
            className="flex-1 max-w-sm cursor-pointer group"
            style={{ backgroundColor: '#FFFFFF' }}
          >
            {/* Image */}
            <div className="relative w-full overflow-hidden" style={{ height: '300px' }}>
              <img
                src={article.image}
                alt={article.title}
                fill
                className="object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            
            {/* Content */}
            <div style={{ paddingTop: '25px', paddingBottom: '25px' }}>
              {/* Category */}
              <p 
                className="italic"
                style={{
                  fontFamily: 'Cardo',
                  fontSize: '14px',
                  color: '#BDA36C',
                  marginBottom: '8px'
                }}
              >
                {article.category}
              </p>
              
              {/* Title */}
              <h3 
                className="group-hover:text-gray-700 transition-colors duration-200"
                style={{
                  fontFamily: 'Cardo',
                  fontSize: '24px',
                  color: '#000000',
                  fontWeight: 'normal',
                  marginBottom: '8px',
                  lineHeight: '1.2'
                }}
              >
                {article.title}
              </h3>
              
              {/* Description */}
              <p 
                style={{
                  fontFamily: 'Plus Jakarta Sans',
                  fontSize: '14px',
                  color: '#7B7B7B',
                  marginBottom: '20px',
                  lineHeight: '1.4'
                }}
              >
                {article.description}
              </p>
              
              {/* Read More Button */}
              <button
                style={{
                  backgroundColor: '#000000',
                  color: '#FFFFFF',
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  fontSize: '14px',
                  padding: '12px 24px',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={() => {
                  // Navigate to article - in a real app, you'd use Next.js router
                  window.location.href = `/editorial/${article.slug}`
                }}
              >
                Read More
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* View All Articles Button */}
      <div 
        className="flex justify-center"
        style={{ marginTop: '64px' }}
      >
        <button
          style={{
            backgroundColor: 'transparent',
            color: '#000000',
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            fontSize: '16px',
            padding: '21px 36px',
            border: '2px solid #000000',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#000000'
            e.currentTarget.style.color = '#FFFFFF'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent'
            e.currentTarget.style.color = '#000000'
          }}
          onClick={() => {
            window.location.href = '/editorial'
          }}
        >
          View All Articles
        </button>
      </div>
    </section>
  )
}